"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.isFreeAddon = isFreeAddon, exports.getCurrencySymbol = getCurrencySymbol, exports.getCostForAddon = getCostForAddon, exports["default"] = getAddonsCost;
var currencySymbols = {
  AUS: "AUD $",
  US: "USD $",
  ASIA_US: "USD $",
  SG: "SGD $",
  UK: "\xA3"
},
    FREE_LANGUAGES = ["EN"];

function getAddonKey(_ref) {
  var addonType = _ref.addonType,
      addonValue = _ref.addonValue;
  return addonValue ? ["DURATION", "RUSH_EDIT"].includes(addonType) ? "STANDARD" === addonValue.value ? "" : addonValue.value : "CHROMA_KEY" === addonType ? addonValue.value ? "CHROMA_KEY" : "" : addonType : "";
}

function isFreeLanguage(_ref2) {
  var language = _ref2.language;
  return FREE_LANGUAGES.includes(language);
}

function isFreeAddon(_ref3) {
  var addonKey = _ref3.addonKey,
      addonValue = _ref3.addonValue,
      includedAddons = _ref3.includedAddons;
  return !!includedAddons.includes(addonKey) || !!(addonValue && ["BURN_IN_CAPTIONS", "SRT_CAPTIONS"].includes(addonKey) && (isFreeLanguage({
    language: addonValue
  }) || includedAddons.includes("".concat(addonKey, "_").concat(addonValue))));
}

function getCurrencySymbol(billingEntityCode) {
  return function () {
    return currencySymbols[billingEntityCode];
  };
}

function getCostForAddon(_ref4) {
  var costs = _ref4.costs,
      billingEntityCode = _ref4.billingEntityCode,
      numberValue = _ref4.numberValue;
  return costs ? numberValue ? costs[billingEntityCode] : "".concat(currencySymbols[billingEntityCode]).concat(costs[billingEntityCode]) : numberValue ? 0 : "".concat(currencySymbols[billingEntityCode], "-");
}

function getAddonsCost(_ref5) {
  var billingEntityCode = _ref5.billingEntityCode,
      includedAddons = _ref5.includedAddons,
      addonsCosts = _ref5.addonsCosts;
  return function (addons) {
    var _ref6 = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
        numberValue = _ref6.numberValue,
        _ref6$isMaster = _ref6.isMaster,
        defaultTotalCost = !(void 0 !== _ref6$isMaster) || _ref6$isMaster ? 0 : getCostForAddon({
      costs: addonsCosts.VIDEO_OUTPUT.costs,
      billingEntityCode: billingEntityCode,
      numberValue: !0
    }),
        totalCost = addons ? Object.keys(addons).reduce(function (total, addonType) {
      var addonValue = addons[addonType],
          addonKey = getAddonKey({
        addonType: addonType,
        addonValue: addonValue
      });
      if (!addonKey) return total;

      var _ref7 = includedAddons.includes(addonKey) ? {} : addonsCosts[addonKey],
          costs = _ref7.costs;

      return addonValue && (Array.isArray(addonValue) || addonValue.value) && "__typename" !== addonType ? Array.isArray(addonValue) ? total + addonValue.reduce(function (valueTotal, srt) {
        return !srt || isFreeAddon({
          addonKey: addonKey,
          addonValue: srt.value,
          includedAddons: includedAddons
        }) ? valueTotal : valueTotal + getCostForAddon({
          costs: costs,
          billingEntityCode: billingEntityCode,
          numberValue: !0
        });
      }, 0) : isFreeAddon({
        addonKey: addonKey,
        addonValue: addonValue.value,
        includedAddons: includedAddons
      }) ? total : total + getCostForAddon({
        costs: costs,
        billingEntityCode: billingEntityCode,
        numberValue: !0
      }) : total;
    }, defaultTotalCost) : 0;

    return numberValue ? totalCost : "".concat(currencySymbols[billingEntityCode]).concat(totalCost);
  };
}